import React, { useContext } from 'react';

type LocaleContextType = {};

export const LocaleContext = React.createContext<LocaleContextType | undefined | null>(undefined);

export function useLocale() {
  return useContext(LocaleContext);
}
